import React, { useEffect, useState } from 'react';

import { config } from '../../../../config/index';
import placeholderImage from '../../../../assets/images/placeholder.jpg';
import docImg from '../../../../assets/icons/document.png';

const { API_URL, SERVER_URL } = config;
const ActivitySidebar = ({
  activeSchedule,
  activeSidebar,
  associate,
  setActiveSidebar,
}) => {
  const token = localStorage.getItem('token');
  const [associateStatusLogs, setAssociateStatusLogs] = useState([]);
  const [backDropSidebar, setBackDropSidebar] = useState(true);

  //fetch associate status
  const fetchAssociateStatusLogs = async () => {
    if (associate.associate_id) {
      let url = `${API_URL}/logs/schedule/${associate?.sched_id}/associate/${associate.associate_id}`;

      try {
        let response = await fetch(url, {
          mode: 'cors',
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        let data = await response.json();

        if (response.ok) {
          setAssociateStatusLogs(data.data);
        } else {
          console.log('Failed to fetch associates');
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (associate?.sched_id) {
      fetchAssociateStatusLogs();
    }
  }, [activeSchedule, associate]);

  return (
    <React.Fragment>
      {activeSidebar && (
        <div
          className="right-sidebar-menu pb-4"
          style={
            backDropSidebar
              ? { overflowY: 'auto', zIndex: '200' }
              : { overflowY: 'auto' }
          }
        >
          <div className="x-button-container">
            <button
              className="x-button"
              onClick={() => setActiveSidebar(!activeSidebar)}
            >
              <img
                src="https://server-mae.manpower.com.sg/public/img/6b5786439c.png"
                alt="x-icon"
              />
            </button>
          </div>
          <div className="sidebar-content">
            {/* User Img Holder */}
            <div className="sidebar-user-holder d-flex align-items-center justify-content-center">
              <img
                className="rounded-circle border me-3"
                style={{ width: '75px', height: '75px' }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = placeholderImage;
                }}
                src={
                  associate.image
                    ? `${SERVER_URL}/${associate.image}`
                    : placeholderImage
                }
                alt="user-sidebar-img"
              />
              <div>
                <span>
                  {associate.last_name_first
                    ? `${associate.last_name} ${associate.first_name}`
                    : `${associate.first_name} ${associate.last_name}`}
                </span>
                <span style={{ color: '#aaa' }}>
                  ID: {associate.employee_id}
                </span>
                <span>(#{associate.employee_no})</span>
              </div>
            </div>


            <div className="flex-grow-1">
              <div className="mt-4">
                <strong className="mt-4">Activity Logs</strong>
              </div>
              <div className="rounded shadow bg-white mt-2 p-4">
                {associateStatusLogs.length > 0
                  ? associateStatusLogs.map((log, index) => (
                      <div
                        key={index}
                        className="d-flex flex-row py-1 align-items-center"
                        style={{ fontSize: 12 }}
                      >
                        <div className="text-muted" style={{ width: '140px' }}>
                          {log.createdAt}
                        </div>
                        <div className="flex-grow-1">{log.activity_logs}</div>
                        {log.capture_photo && (
                          <div className="ms-2">
                            <a
                              href={`${SERVER_URL}/${log.capture_photo}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="d-flex align-items-center"
                            >
                              <img
                                src={docImg}
                                alt="Capture Photo"
                                className="me-2"
                                style={{
                                  width: '24px',
                                  height: '24px',
                                  cursor: 'pointer',
                                }}
                                title="View captured photo"
                              />
                            </a>
                          </div>
                        )}
                      </div>
                    ))
                  : 'No activity logs.'}
              </div>
            </div>


          </div>
        </div>
      )}

      {activeSidebar && backDropSidebar && (
        <div
          className="modal-backdrop fade in"
          style={{ opacity: '0.3', zIndex: '100' }}
          onClick={() => {
            setActiveSidebar(false);
          }}
        ></div>
      )}
    </React.Fragment>
  );
};

export default ActivitySidebar;
